import { useStarterOnboardingPageData } from 'src/app/pages/starterOnboarding/pageContext';
import type { OnlineShareChannel } from 'src/app/pages/starterOnboarding/shared/types';

export function useStarterOnboardingShareChannels(): readonly OnlineShareChannel[] {
	const {
		data: {
			petition: { geoReach },
			fcms: { globalShareButtonConfig },
		},
	} = useStarterOnboardingPageData();

	if (globalShareButtonConfig.includes('nextdoor') && geoReach !== 'local') {
		return globalShareButtonConfig.filter((ch) => ch !== 'nextdoor');
	}

	return globalShareButtonConfig;
}
